module.exports = __webpack_public_path__ + "img/mobile_home_download_banner_background.1561cca2.png";